import { pick } from "lodash";
import * as Yup from "yup";

export const formValidation = {
  email: Yup.string()
    .email(
      `Our magical machines are saying this doesn't look like a valid email. Try again?`
    )
    .required("Please enter an email so we can send you love letters"),

  settlementType: Yup.array()
    .min(1, "Please select a settlement type")
    .required(),
  sourceFi: Yup.array().min(1, "Please select a source"),
  targetFi: Yup.array().min(1, "Please select a target").required(),
  sourceCcy: Yup.string().required("Please enter a source currency"),
  transferCryptoCcy: Yup.string().required(
    "Please enter the crypto to be used"
  ),
  targetFiatCcy: Yup.string().required("Please enter a target currency"),
  settlementAmt: Yup.number().required("Please enter a send amount"),
  almondFee: Yup.number().required("Please enter Almonds fee"),
  sourceCryptoExchange: Yup.string(),
  targetCryptoExchange: Yup.string().required("Please enter a target exchange"),
};

export const settlementValidationSchema = Yup.object().shape(
  pick(formValidation, [
    "settlementType",
    "sourceFi",
    "targetFi",
    "sourceCcy",
    "transferCryptoCcy",
    "targetFiatCcy",
    "settlementAmt",
    "receivedAmt",
    "almondFee",
    "sourceCryptoExchange",
    "targetCryptoExchange",
  ])
);
